import { StringParam, useQueryParams, withDefault } from 'use-query-params';

import { INSIGHTS_QUERY_KEY } from '@insights_module/constants/queryKeys';
import { GarmResultsType, GarmOverviewRisks } from '@insights_module/types/BrandSafety';

export const useGarmParams = () => {
  const [query, setQuery] = useQueryParams({
    [INSIGHTS_QUERY_KEY.adult_explicit_content]: withDefault(StringParam, 'floor'),
    [INSIGHTS_QUERY_KEY.arms_ammunition]: withDefault(StringParam, 'floor'),
    [INSIGHTS_QUERY_KEY.crime_harmful_act]: withDefault(StringParam, 'floor'),
    [INSIGHTS_QUERY_KEY.death_injury_military_conflict]: withDefault(StringParam, 'floor'),
    [INSIGHTS_QUERY_KEY.debated_social]: withDefault(StringParam, 'floor'),
    [INSIGHTS_QUERY_KEY.hate_speech]: withDefault(StringParam, 'floor'),
    [INSIGHTS_QUERY_KEY.illegal_drugs]: withDefault(StringParam, 'floor'),
    [INSIGHTS_QUERY_KEY.obscenity]: withDefault(StringParam, 'floor'),
    [INSIGHTS_QUERY_KEY.online_piracy]: withDefault(StringParam, 'floor'),
    [INSIGHTS_QUERY_KEY.spam_harmful]: withDefault(StringParam, 'floor'),
    [INSIGHTS_QUERY_KEY.terrorism]: withDefault(StringParam, 'floor'),
  });

  const _garmParams = Object.keys(query);

  const setAllGarmParams = (option: GarmResultsType | keyof GarmOverviewRisks | undefined) => {
    if (!option && option !== undefined) {
      return;
    }

    // set all params as option being set of key value pairs
    if (typeof option === 'object') {
      Object.entries(option).forEach(([key, value]) => {
        setQuery(
          {
            [key]: value,
          } as { [key: string]: string },
          'pushIn'
        );
      });

      return;
    }

    //set all params as option being risk level value
    _garmParams.forEach((param) => {
      setQuery(
        {
          [param]: option,
        },
        'pushIn'
      );
    });
  };

  return { garmParams: query, setGarmParams: setQuery, setAllGarmParams };
};
